"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoveCharacterVfxStepArgs = void 0;
const uuid_1 = require("uuid");
const LocationSelector_1 = require("../LocationSelector");
class MoveCharacterVfxStepArgs {
    constructor(subject, destination, speed = 1, returnToStart = true) {
        this.subject = subject;
        this.destination = destination;
        this.speed = speed;
        this.returnToStart = returnToStart;
        this.__typeName = "MoveCharacter";
        this.id = (0, uuid_1.v4)();
    }
}
exports.MoveCharacterVfxStepArgs = MoveCharacterVfxStepArgs;
MoveCharacterVfxStepArgs.MoveAndReturn = (originId, destination) => ({
    moveToVfx: new MoveCharacterVfxStepArgs(originId, destination, 1, false),
    returnToVfx: new MoveCharacterVfxStepArgs(originId, new LocationSelector_1.ActorGridLocationSelector(originId), 1, false),
});
